<template lang="pug">
    .main 
        #local_video
        #remote_video
        .reject-wrap.col.col-center 
            .col.center(@click='handUp')
                img(src='~@/assets/image/icon_endCall@2x.png')
                p 挂断
    </template>
    
    <script>
    import eventEmitter from '@/utils/bus'
    export default {
        mounted() {
            const param = this.$route.query
            this.dragEvent()
            this.$trtcCalling.acceptClient(param)
            eventEmitter.on('cancelVideo', () => {
                this.$router.back(0)
            })
        },
        computed: {},
        methods: {
            handUp() {
                this.$trtcCalling.hangupClient()
            },
            dragEvent() {
                let box = document.getElementById('local_video')
                box.onmousedown = function(e) {
                    var eC = e || window.event // 兼容ie浏览器
                    var diffX = eC.clientX - box.offsetLeft // 鼠标点击物体那一刻相对于物体左侧边框的距离=点击时的位置相对于浏览器最左边的距离-物体左边框相对于浏览器最左边的距离
                    var diffY = eC.clientY - box.offsetTop
    
                    document.onmousemove = function(event) {
                        var eventC = event || window.event // 兼容ie浏览器
                        var left = eventC.clientX - diffX
                        var top = eventC.clientY - diffY
    
                        // 控制拖拽物体的范围只能在浏览器视窗内，不允许出现滚动条
                        if (left < 0) {
                            left = 0
                        } else if (left > window.innerWidth - box.offsetWidth) {
                            left = window.innerWidth - box.offsetWidth
                        }
                        if (top < 0) {
                            top = 0
                        } else if (top > window.innerHeight - box.offsetHeight) {
                            top = window.innerHeight - box.offsetHeight
                        }
                        console.log('ddddddd')
    
                        // 移动时重新得到物体的距离，解决拖动时出现晃动的现象
                        box.style.left = left + 'px'
                        box.style.top = top + 'px'
    
                        document.onmouseup = function() {
                            document.onmousemove = null
                            document.onmouseup = null
                        }
                    }
                }
            },
        },
    }
    </script>
    <style lang="stylus" scoped>
    .main
        width: 100vw
        height: 100vh
        position: relative
        font-size: 16px
        #local_video
            width: 106px
            height: 188px
            position: absolute
            right: 0
            top: 20px
            background: #fff
            z-index: 1
        #remote_video
            height: 100%
            width: 100%
            background: #333
        .reject-wrap
            position: absolute
            z-index: 1
            bottom: 88px
            width: 100vw
            left: 0
            img
                width: 64px
                height: 64px
            p
                font-size: 14px
                color: #FFFFFF
                margin-top: 8px
    </style>
    